// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__f5SW-","credit":"Footer_credit__cqI4Q"};